export default "__VITE_ASSET__xdOtAgfD__"